import React from "react";
import { useHistory } from "react-router-dom";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import SessionError from "../ApiErrorComp/SessionError";
import { LoadingOutlined } from "@ant-design/icons";

function ImageView({ onClick, setPageHeader, _id, height, width, spinSize, src, urlData, source = 'dynamic', isCacheble }) {
  if (setPageHeader) {
    setPageHeader("Image View");
  }
  const history = useHistory();

  const [loginError, setLoginError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [img, setImg] = React.useState(null);

  const query = new URLSearchParams(history.location.search);

  // const id = query.get("_id");




  let id; // Declare id outside of the if-else blocks

  // Check if "altId" exists in the query parameters
  if (query.has("altId")) {
    // If "altId" exists, use it to get the "id"
    id = query.get(query.get("altId"));
  } else {
    // If "altId" doesn't exist, fall back to using "_id"
    id = query.get("_id");
  }



  // console.log(id);

  React.useEffect(() => {
    if (source === 'dynamic') {
      let pData = id ? id : _id;
      let cacheKey = '';
      if (urlData) {
        Object.values(urlData).forEach((x, i) => {
          cacheKey += `${x}`;
          if (i < (Object.values(urlData).length - 1)) {
            cacheKey += '-'
          }
        });
      } else {
        cacheKey = pData;
      }
      let cacheImg = localStorage.getItem(`cache_img_${cacheKey}`);
      if (cacheImg) {
        setImg(cacheImg);
        setLoading(false);
        return;
      }
      liracrypt
        .get("/imagecontrol", urlData || { _id: pData })
        .then((res, req) => {
          if (res.data.isSuccess) {
            setImg(res.data.data);
            if (isCacheble && res.data.data) {
              localStorage.setItem(`cache_img_${cacheKey}`, res.data.data);
            }
          } else {
            let noImg = require(`../../assets/static/noImg.jpeg`);
            setImg(noImg);
            localStorage.setItem(`cache_img_${cacheKey}`, noImg);
          }

          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              // ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else if (source === 'cdn') {
      setImg(src);
      setLoading(false);
    } else {
      try {
        let staticImg = require(`../../assets/static/${src}`);
        setImg(staticImg);
      } catch (ex) {

        let noImg = require(`../../assets/static/noImg.jpeg`)
        setImg(noImg)
      }
      setLoading(false);
    }
  }, []);

  return (
    <>
      <SessionError visible={loginError} />
      <div
        style={{
          display: "flex",
          height: height ? height : "100vh",
          width: width ? width : "auto",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!loading ? (
          <img onClick={onClick} src={img || ''} height="100%" width="100%" />
        ) : (
          <>
            <LoadingOutlined
              style={{ fontSize: spinSize ? spinSize : 80, color: "#dc3545" }}
              spin
            />
          </>
        )}
      </div>
    </>
  );
}

export default ImageView;
